import { useEffect, useMemo } from "react";
import { Button, LegacyStack, Spinner } from "@shopify/polaris";
import { useActiveOrganizationSelector } from "@vendor-app/app/_state/reducers/organizations";
import { useThemeCustomizationUrl } from "@vendor-app/app/AdminRoute/AdminSetupRoute/libs/utils";
import { parseShopName } from "@smartrr/shared/utils/parseShopName";
import { GettingStartedStoreAccess } from "../../../libs/store";
import { isEmpty } from "lodash";
import { useCheckIfThemeIsValid } from "../../../libs/hooks/useCheckIfThemeIsValid";
import { SellingPlanGroupStoreAccess } from "@vendor-app/app/_state/zustand/SellingPlansStore";

export const SubscriptionWidgetButton = () => {
  const isLoading = GettingStartedStoreAccess.useLoading("subscriptionBlock");
  const themes = GettingStartedStoreAccess.useThemes();
  const { isThemeValid } = GettingStartedStoreAccess.useThemeValidation();
  const { update } = GettingStartedStoreAccess.useActions();

  const chosenThemeId = GettingStartedStoreAccess.useChosenThemeId();

  const sellingPlanGroups = SellingPlanGroupStoreAccess.useGroups();
  const isSellingPlanGroupsLoading = SellingPlanGroupStoreAccess.useAreGroupsLoading();
  const sellingPlanGroupActions = SellingPlanGroupStoreAccess.useActions();

  const { checkIfThemeIsValid } = useCheckIfThemeIsValid();

  const org = useActiveOrganizationSelector();
  const { shopName } = parseShopName(org?.myShopifyDomain);

  const themeCustomizeLink = useThemeCustomizationUrl(shopName, chosenThemeId, "/products", sellingPlanGroups);

  const disabled = useMemo(
    () =>
      !isThemeValid ||
      !themes.length ||
      !chosenThemeId ||
      isEmpty(themeCustomizeLink) ||
      isSellingPlanGroupsLoading,
    [isThemeValid, themes.length, chosenThemeId, themeCustomizeLink, isSellingPlanGroupsLoading]
  );

  const clickHandler = () => {
    update(
      [
        {
          path: "snippetsThemeId",
          val: chosenThemeId,
        },
      ],
      "subscriptionBlock"
    );
  };

  useEffect(() => {
    void checkIfThemeIsValid(chosenThemeId!);
  }, [themes, chosenThemeId]);

  useEffect(() => {
    void sellingPlanGroupActions.fetchSellingPlanGroups(false);
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <LegacyStack vertical>
      <div data-testid="app-block-go-to-shopify-button">
        <Button primary disabled={isLoading || disabled} external url={themeCustomizeLink} onClick={clickHandler}>
          Go to Shopify to add block
        </Button>
      </div>
    </LegacyStack>
  );
};
